import React from "react";
import DateHelper from "../DateHelper/DateHelper";

const ChannelLeadBuilderGeneral = ({...props}) => {
  return(
    <div className="tab-content">
      <div className="row">
        <div className="col-md-3">
          <div className="form-group">
            <label>
              {I18n.t('status')}
            </label>
            {renderStatusesSelect(props)}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <label>
            {I18n.t('name')}
          </label>
          <p>
            {`${props.channelLead.first_name} ${props.channelLead.last_name}`}
          </p>
        </div>
        <div className="col-md-3">
          <label>
            {I18n.t('check_in_date')}
          </label>
          <p>
            {DateHelper.printDateToScreen(props.channelLead.check_in_date, props.date_format)}
          </p>
        </div>
        <div className="col-md-3">
          <label>
            {I18n.t('check_out_date')}
          </label>
          <p>
            {DateHelper.printDateToScreen(props.channelLead.check_out_date, props.date_format)}
          </p>
        </div>
        <div className="col-md-3">
          <label>
            {I18n.t('room_type')}
          </label>
          <p>
            {
              props.channelLead.room_type
              ? 
              `${props.channelLead.room_type.name}(${props.channelLead.room_type.code})`
              : 
              I18n.t('none')
            }
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <label>
            {I18n.t('phone')}
          </label>
          <p>
            {props.channelLead.phone}
          </p>
        </div>
        <div className="col-md-3">
          <label>
            {I18n.t('email')}
          </label>
          <p>
            {props.channelLead.email}
          </p>
        </div>
        <div className="col-md-3">
          <label>
            {I18n.t('source')}
          </label>
          <p>
            {props.channelLead.ru_creator}
          </p>
        </div>
        <div className="col-md-3">
          <label>
            {I18n.t('inquiry_date')}
          </label>
          <p>
            {DateHelper.printDateToScreen(props.channelLead.ru_date_entered, props.date_format)}
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-md-8">
          <label>
            {I18n.t('inquiry_comment')}
          </label>
          <p>
            {props.channelLead.comment}
          </p>
        </div>
      </div>
    </div>
  );
};

const renderStatusesSelect = (props) => {
  const options = Object.keys(props.statuses_obj).map(key => <option key={key} value={key}>{key}</option>);
  return(
    <select className="form-control" name="status" valeu={props.channelLead.status} onChange={props.onChange}>
      {options}
    </select>
  );
};

export default ChannelLeadBuilderGeneral